export * from './FridgeIcon'
